import React, { useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/effect-cards";
import "./swiper.css";
import { EffectCards } from "swiper";

 function SwiperComp(props) {
  const Data=props.Data;
  return (
    <>
      <Swiper
        effect={"cards"}
        grabCursor={true}
        modules={[EffectCards]}
        className="mySwiper2"
      >
        {Data.map((image,id)=>{
          return(
            image.Mix.map((img,id)=>{
              return (

                <SwiperSlide id={id}>
              
              <img src={img.url} alt={img.name} />
      
            </SwiperSlide>
            )
            })
            
            )
            
          })}
       
      </Swiper>
    </>
  );
}
export default SwiperComp;
